// @ts-check
export function getWorkerHealthCertifications(worker) {
  const userBadges = [];

  if (worker.isVaccinated) {
    userBadges.push({
      icon: "images/cert-icons/medical-instrument-syringe-1.svg",
      toolTip: "Fully Vaccinated Against Covid-19",
      title: "Fully Vaccinated Against Covid-19",
    });
  }

  if (worker.is_covid_exempt) {
    userBadges.push({
      icon: "images/cert-icons/medical-instrument-syringe-inactive.svg",
      toolTip: "Medically or Religiously Exempt",
      title: "Medically or Religiously Exempt",
    });
  }

  return userBadges;
}

export function getWorkerCertifications(worker) {
  const userBadges = [];

  if (worker.status === "ELIGIBLE") {
    userBadges.push({
      icon: "images/cert-icons/background-check.svg",
      toolTip: "Basic Background Check passed",
      title: "Level 1 background check passed",
    });
  }

  if (worker.military) {
    userBadges.push({
      icon: "images/cert-icons/military.svg",
      toolTip: "Military Veteran",
      title: "Military Veteran",
    });
  }

  if (worker.passedDMV) {
    userBadges.push({
      icon: "images/cert-icons/clean-dmv.svg",
      toolTip: "Clean DMV Record",
      title: "Clean DMV",
    });
  }

  return userBadges;
}
